export const apiOriginUrl: string = 'https://api.amitel.azureo.eu';
export const ceriServerUrl: string = 'https://api.amitel.eu:2323/api_amitel/';

export const environment = {
  production: false,
  local: '/assets/data',
  origin: `${apiOriginUrl}`,
  apiV1: '/api/v1/',
  service: {
    user: '/bff/service-user',
    core: '/bff/service-core'
  },
  ceriServerUrl,
  auth0: {
    domain: 'https://amitel-stage.eu.auth0.com',
    clientId: 'AyaXBiBSlzVDr5xnlHUlfvM06aiO5SWQ',
    audience: 'https://api.amitel.azureo.eu'
  },
};
